"use strict";import{Thumbnail as e}from"./src/Thumbnail.js";import{defineElement as m}from"@spectrum-web-components/base/src/define-element.js";m("sp-thumbnail",e);
//# sourceMappingURL=sp-thumbnail.js.map
